export default {
    lang: {
        name: 'Last played during date range'
    }
}